import React from 'react';
import 'katex/dist/katex.min.css';
import { InlineMath, BlockMath } from 'react-katex';

/**
 * Renders text with LaTeX support.
 * Inline math: $...$   Block math: $$...$$
 * Falls back to plain text if no LaTeX found.
 */
export default function MathRenderer({ text, className = '' }) {
  if (!text) return null;

  // Split by $$...$$ (block) and $...$ (inline)
  const parts = [];
  let remaining = text;
  let key = 0;

  // First handle block math $$...$$
  while (remaining.includes('$$')) {
    const startIdx = remaining.indexOf('$$');
    const endIdx = remaining.indexOf('$$', startIdx + 2);
    if (endIdx === -1) break;

    // Text before block math
    if (startIdx > 0) {
      parts.push(...parseInlineMath(remaining.substring(0, startIdx), key));
      key += 100;
    }

    // Block math
    const latex = remaining.substring(startIdx + 2, endIdx);
    try {
      parts.push(<BlockMath key={`block-${key++}`} math={latex} />);
    } catch {
      parts.push(<span key={`fallback-${key++}`} className="font-mono text-sm">{latex}</span>);
    }

    remaining = remaining.substring(endIdx + 2);
  }

  // Handle remaining text with inline math
  if (remaining) {
    parts.push(...parseInlineMath(remaining, key));
  }

  if (parts.length === 0) {
    return <span className={className}>{text}</span>;
  }

  return <span className={className}>{parts}</span>;
}

function parseInlineMath(text, startKey = 0) {
  const parts = [];
  let remaining = text;
  let key = startKey;

  while (remaining.includes('$')) {
    const startIdx = remaining.indexOf('$');
    const endIdx = remaining.indexOf('$', startIdx + 1);
    if (endIdx === -1) break;

    // Text before inline math
    if (startIdx > 0) {
      parts.push(<span key={`text-${key++}`}>{remaining.substring(0, startIdx)}</span>);
    }

    // Inline math
    const latex = remaining.substring(startIdx + 1, endIdx);
    try {
      parts.push(<InlineMath key={`inline-${key++}`} math={latex} />);
    } catch {
      parts.push(<span key={`fallback-${key++}`} className="font-mono text-sm">{latex}</span>);
    }

    remaining = remaining.substring(endIdx + 1);
  }

  // Any remaining text
  if (remaining) {
    parts.push(<span key={`text-${key++}`}>{remaining}</span>);
  }

  return parts;
}
